// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "25873" ? "vertical-insure" : chunkId) + "-" + {"25873": "cf5a9e5d6e7bd75f","81505": "77fa1b6a984ffb8e",}[chunkId] + ".js"
}